import React, { useState } from "react";
import { Collapse } from "reactstrap";
import { FAQ_ITEMS } from "../../landingContent";
import SectionHeading from "../SectionHeading";

const FaqSection = ({ faqRef }) => {
  const [openFaqId, setOpenFaqId] = useState(null);

  return (
    <section
      id="faq"
      ref={faqRef}
      className="landing-v2__section landing-v2-faq"
      aria-labelledby="faq-heading"
    >
      <div className="landing-v2__container">
        <SectionHeading headline="Frequently asked questions" headingLevel={2} />

        <div className="landing-v2-faq__list" style={{ marginTop: "2rem" }}>
          {FAQ_ITEMS.map(({ id, question, answer }) => {
            const isOpen = openFaqId === id;

            return (
              <div key={id} className="landing-v2-faq__item">
                <button
                  type="button"
                  id={`faq-question-${id}`}
                  className={`landing-v2-faq__question ${isOpen ? "landing-v2-faq__question--open" : ""}`}
                  onClick={() => setOpenFaqId(isOpen ? null : id)}
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${id}`}
                >
                  {question}
                  <i
                    className={`fa ${isOpen ? "fa-chevron-up" : "fa-chevron-down"} landing-v2-faq__chevron`}
                    aria-hidden="true"
                  />
                </button>
                <Collapse isOpen={isOpen}>
                  <div
                    id={`faq-answer-${id}`}
                    className="landing-v2-faq__answer"
                    role="region"
                    aria-labelledby={`faq-question-${id}`}
                  >
                    {answer}
                  </div>
                </Collapse>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
